<div #imageWrapper [className]="imageWrapperCls">
  <div class="inline-style" [innerHtml]="mediaQueryStyles | safeHtml"></div>
  <a
    role="button"
    *ngIf="url && url.length > 0; else inlineImage"
    [href]="url[0].uri"
    (click)="navigate($event, url[0].uri)"
    [target]="url[0].options.attributes.target === 1 ? '_blank' : ''"
    [rel]="url[0].options.attributes.rel || 'noopener'"
    [attr.analytics-alternate-text]="analyticsLinkText"
    [class]="url[0].options.attributes.class"
  >
    <ng-container *ngTemplateOutlet="inlineImage"></ng-container>
  </a>
</div>

<ng-template #inlineImage>
  <div [className]="imageWrapperMiddleCls">
    <div [className]="imageWrapperInnerCls" [ngStyle]="innerWrapperCls">
      <picture>
        <source
          [media]="mq.mobile"
          [srcset]="mobileWebpMedia.src | encodePath"
          [type]="getMediaType(mobileWebpMedia.src)"
        />
        <source
          [media]="mq.midsize"
          [srcset]="midWebpMedia.src | encodePath"
          [type]="getMediaType(midWebpMedia.src)"
        />
        <source
          [media]="mq.desktop"
          [srcset]="desktopWebpMedia.src | encodePath"
          [type]="getMediaType(desktopWebpMedia.src)"
        />
        <source
          [srcset]="fallbackWebpMedia.src | encodePath"
          [type]="getMediaType(fallbackWebpMedia.src)"
        />
        <img
          [id]="inlineImageId"
          [attr.loading]="loading?.value"
          [src]="emptyCmsImage.src | encodePath"
          [alt]="mobileWebpMedia.alt || desktopWebpMedia.alt"
          [ngClass]="imageCls"
        />
      </picture>
    </div>
  </div>
</ng-template>
